
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoginLogo from '../../Assets/images/Frame 39059 1.png';
import LoginImg from '../../Assets/images/Loginimage-woman-smile-happy-joy 1.png';
import BackgroundImage from '../../Assets/images/LoginAndSignUpBG.png';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../config';
const ForgotPassWord = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  // Initialize state with values from sessionStorage
  const [phoneNumber, setPhoneNumber] = useState(
    () => sessionStorage.getItem('phoneNumber') || ''
  );

  // Update sessionStorage whenever state changes
  useEffect(() => {
    sessionStorage.setItem('phoneNumber', phoneNumber);
  }, [phoneNumber]);

  // Function to send forgot password OTP
  const handleForgotPassOtp = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/account/forgot-password/`,
        // 'https://finwise-backend.vercel.app/account/forgot-password/',
        // 'https://finwiseback.finwise.com.bd/account/forgot-password/',
        // 'http://127.0.0.1:8000/account/forgot-password/',
        { phone: phoneNumber },
        {
          headers: {
            'Content-Type': 'application/json',
            // Cookie: 'sessionid=vonpwnmq5904ndb7w395ect6tmgzey2r',
            'X-CSRFToken': 'z91BDRm6OBq66qusVK8HCtvtdW686hFC',
          },
          withCredentials: true,
        }
      );
      console.log(response.data);
      // Show success alert
      Swal.fire({
        // icon: 'success',
        title: 'OTP Sent!',
        text: 'Please check your OTP.',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
      navigate('/forgotPassOtp');
    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        // icon: 'error',
        title: 'Error!',
        text: 'Failed to send. Please try again.',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!phoneNumber) newErrors.username = 'Mobile number is required';
    return newErrors;
  };

  const handleSignUpKey = e => {
    if (e.key === 'Enter') handleForgotPassOtp();
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen md:py-0 py-2 md:mt-20 mt-20"
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      <div className="bg-white md:p-6 p-8 lg:pl-10 lg:pr-10 gap-10 shadow-xl rounded-xl ">
        <div className="items-center justify-center flex">
          <img
            src={LoginLogo}
            alt="LoginLogo"
            className="md:h-14 h-10 lg:h-16 mb-0 pr-10 lg:mb-1"
          />
        </div>
        <h2 className="items-center justify-center flex lg:font-bold lg:mb-4 text-xs lg:text-sm">
          Trade and Finance Solutions
        </h2>

        <div className="items-center justify-center flex flex-col lg:flex-row gap-10">
          <div className="lg:block hidden">
            <img
              src={LoginImg}
              alt="LoginImg"
              className="md:h-32 h-32 lg:h-44"
            />
          </div>

          <div>
            <h2 className="text-xl text-center lg:text-2xl font-semibold mt-1 mb-4 heading">
              Forget Password
            </h2>

            <div className="w-full lg:w-[400px] space-y-4 mt-2">
              <div className="flex flex-col space-y-4 text-xs">
                <input
                  type="text"
                  placeholder="+880 Mobile Number"
                  className="border border-gray-300 rounded-md py-2 px-4 w-full"
                  value={phoneNumber}
                  onChange={e => setPhoneNumber(e.target.value)}
                  onKeyDown={handleSignUpKey}
                />
                {errors.username && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    {errors.username}
                  </p>
                )}
              </div>

              <button
                onClick={handleForgotPassOtp}
                className="w-full bg-orange-300 text-white py-2 px-6 hover:bg-btnHover mb-2 mt-2 rounded-2xl text-xs font-bold"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassWord;
